import { useState } from "react";
import { faqs } from "@/mocks/chigua";
import Reveal from "./Reveal";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const faqSchema = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  });

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: faqSchema }}
      />
      <section id="faq" className="scroll-mt-24">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <Reveal>
            <div className="mx-auto max-w-3xl">
              <div className="text-center">
                <p className="inline-flex items-center gap-2 font-label text-xs font-bold uppercase tracking-widest text-primary-600">
                  <i className="ri-questionnaire-line text-accent-500"></i>
                  FAQ
                </p>
                <h2 className="rule-head mt-3 inline-block font-heading text-2xl font-black text-foreground-950">
                  常见问题解答
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-foreground-500">
                  关于内容更新、栏目覆盖、线索投稿与转载规范，这里都有答案。
                </p>
              </div>

              <div className="mt-8 space-y-3">
                {faqs.map((f, idx) => {
                  const isOpen = open === idx;
                  return (
                    <div
                      key={f.q}
                      className={`overflow-hidden rounded-lg border bg-background-50 transition ${
                        isOpen ? "border-primary-300" : "border-background-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : idx)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center gap-3 px-5 py-4 text-left"
                      >
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-label text-sm font-black ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                          }`}
                        >
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                        <h3 className="flex-1 font-heading text-base font-bold text-foreground-950">
                          {f.q}
                        </h3>
                        <i
                          className={`ri-add-line text-lg text-foreground-400 transition-transform duration-300 ${
                            isOpen ? "rotate-45 text-primary-500" : ""
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="px-5 pb-5 pl-16 text-sm leading-relaxed text-foreground-600">
                            {f.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}